<template>
  <component is="div" v-html="htmlDynamicFilters(tally())"></component>
</template>

<script>
import {mapGetters} from 'vuex'
import TextHtml from "@/x-html/TextHtml";

export default {
  extends: TextHtml,

  computed: {
    ...mapGetters(['tally']),
  },
}
</script>
